import { CountriesException } from '@/domain/statics/repository/contract/exception/CountriesException'

export class UnknownCountriesException extends CountriesException {

}
